import { AccountInfo, PublicClientApplication } from '@azure/msal-browser';
import { al } from './auth-config';
import { getUserInfoFromToken } from '../utils/utils';
import { setUserEvent } from '../../RumUtility';
const env = (<any>window)["appenv"];

export enum AuthorizationRoles {
    MaerskInternal = "MaerskInternalUser",
    FleetSurveyorCompany = "FleetSurveyorCompany",
    FleetSurveyor = "FleetSurveyor",
    AllRead = "StarConnect-Voyage.ReadAll",
    AllReadWrite = "StarConnect-Voyage.WriteAll",
    PlanVessel = "StarConnect-Voyage-Config-RequestPlanVessels.Edit",
    WeatherLimitRead = "StarConnect-Voyage-Config-Weatherlimits.Read",
    WeatherLimitWrite = "StarConnect-Voyage-Config-Weatherlimits.Write",
    AlarmEdit = "StarConnect-Voyage-Alarms.Edit",
}
export const AuthService = new class extends EventTarget
{
    constructor()
    {
        super();

        if (env.authRequired)
        {
            if (this._injectedTokens)
            {
                // Use injected token(s)
                this._isLoggedIn = true;
                this._loginPending = false;
            }
            else
            {
                this._loginPending = true;
                this.dispatchEvent(new Event("login-required") )    
            }
        }
    }



    get isLoggedIn() {
        return this._isLoggedIn;
    }

    get loginPending() {
        return this._loginPending;
    }

    doAuth()
    {
        al.loginRedirect({

            /**
           * @type: string
           * @default: "code"
             * @description: the response type
             */
            response_type: 'token id_token',
            
            /**
             * @type: string[]
             * @default: ["openid", "profile", "email"]
               * @description: the scope of the access in the initial request
               */
              scopes: ["openid", "profile", "email"]
            });  
    }

    private _isLoggedIn = false;
    private _loginPending = true;
    private _publicClientApplication: PublicClientApplication|null = null;
    private _injectedTokens = localStorage.getItem((<any>window)["appenv"].loginInfo?.idToken);
    
    public getActiveAccount(): AccountInfo | null | undefined {
        return this._publicClientApplication?.getActiveAccount()
    }

    public userHasRole(role: string): boolean {
        const idToken = localStorage.getItem((<any>window)["appenv"].loginInfo?.idToken)
        if(!idToken) return false
        let userRoles = getUserInfoFromToken(idToken)?.roles || []
        return userRoles?.includes(role)
    }

    public getUserDetails() {
        const idToken = localStorage.getItem((<any>window)["appenv"].loginInfo?.idToken)
        if(!idToken) return false
        return getUserInfoFromToken(idToken)?.username
    }

    public logOut(){
        this._isLoggedIn = false
        this._loginPending = false;
        this.dispatchEvent(new Event('login-required'));
    }

    public  getCurrentUser(): any {
        const idToken = localStorage.getItem((<any>window)["appenv"].loginInfo?.idToken)
        if(!idToken) return false
        let userEmail = getUserInfoFromToken(idToken)?.email
        let userName = getUserInfoFromToken(idToken)?.username
        let userRoles = getUserInfoFromToken(idToken)?.roles || []
        setUserEvent(userEmail, userName, userRoles);
        
    }
    public  getCurrentUserId(): any {
        const idToken = localStorage.getItem((<any>window)["appenv"].loginInfo?.idToken)
        if(!idToken) return false    
        let userName = getUserInfoFromToken(idToken)?.username
       return userName
        
    }

    public  getCurrentUserdisplayName(): any {

        const idToken = localStorage.getItem((<any>window)["appenv"].loginInfo?.idToken)
        if(!idToken) return false    
        let userName = getUserInfoFromToken(idToken)?.name
       return userName
    }
}
